import { useState, useEffect } from 'react'
import { supabase, funzioneUrl } from '../lib/supabase'
import { useAuth } from '../lib/AuthContext'
import TopBar from './TopBar'
import PaginaNotifiche from './PaginaNotifiche'
import PannelloSponsor from './PannelloSponsor'
import { comeLista } from '../lib/formati'

export default function PannelloAdmin() {
  const { profilo } = useAuth()
  const [mostraNotifiche, setMostraNotifiche] = useState(false)
  const [utenti, setUtenti] = useState([])
  const [caricamento, setCaricamento] = useState(true)
  const [tab, setTab] = useState(() => {
    const t = sessionStorage.getItem('fp_admin_tab')
    if (t) { sessionStorage.removeItem('fp_admin_tab'); return t }
    return 'iscritti'
  })
  const [contenutiTabIniziale] = useState(() => {
    const s = sessionStorage.getItem('fp_admin_subtab')
    if (s) { sessionStorage.removeItem('fp_admin_subtab'); return s }
    return 'guida'
  })
  const [emailRegalo, setEmailRegalo] = useState('')
  const [pianoRegalo] = useState('coach')
  const [mesiRegalo, setMesiRegalo] = useState(1)
  const [regaloCreato, setRegaloCreato] = useState(null)
  const [emailInviataStato, setEmailInviataStato] = useState(null) // null | 'invio' | 'ok' | 'errore'
  const [toast, setToast] = useState('')

  // Stato gestione esercizi
  const [esercizi, setEsercizi] = useState([])
  const [esercizioEdit, setEsercizioEdit] = useState(null)
  const [variantiEdit, setVariantiEdit] = useState([])
  const [regressioniEdit, setRegressioniEdit] = useState([])
  const [filtroCategoria, setFiltroCategoria] = useState('Tutte')
  const [ricercaEx, setRicercaEx] = useState('')
  const [confermaEliminaEx, setConfermaEliminaEx] = useState(null)

  // ── Gestione utente ──
  const [utenteSel, setUtenteSel] = useState(null)           // utente aperto nel modale dettaglio
  const [confermaElimina, setConfermaElimina] = useState(null)
  const [emailConferma, setEmailConferma] = useState('')
  const [dataPersonalizzata, setDataPersonalizzata] = useState('')
  const [motivoBlocco, setMotivoBlocco] = useState('')
  const [noteAdmin, setNoteAdmin] = useState('')
  const [ricercaUtente, setRicercaUtente] = useState('')
  const [salvando, setSalvando] = useState(false)
  const [estendiConfermato, setEstendiConfermato] = useState(null) // { giorni, nuovaScadenza } dopo estensione

  // ── Gift token ──
  const [giftEmail, setGiftEmail] = useState('')
  const [giftPiano, setGiftPiano] = useState('atleta')
  const [giftMesi, setGiftMesi] = useState(1)
  const [giftCreato, setGiftCreato] = useState(null)

  // ── Fase C ──
  const [ricercaIscritti, setRicercaIscritti] = useState('')
  const [filtroIscritti, setFiltroIscritti] = useState('tutti')
  const [contenuti, setContenutiState] = useState({ guida: '', privacy: '', tos: '' })
  const [contenutiTab, setContenutiTab] = useState(contenutiTabIniziale)
  const [contenutiCaricati, setContenutiCaricati] = useState(false)
  const [salvandoContenuti, setSalvandoContenuti] = useState(false)
  const [manutenzione, setManutenzione] = useState({ attiva: false, messaggio: '' })
  const [salvandoManutenzione, setSalvandoManutenzione] = useState(false)

  // ── Vista Coach ──
  const [gruppiCoach, setGruppiCoach] = useState([])
  const [gruppiCaricati, setGruppiCaricati] = useState(false)
  const [coachAperto, setCoachAperto] = useState(null)  // id del coach con accordion aperto

  // ── Richieste utenti ──
  const [richiesteAdmin, setRichiesteAdmin] = useState([])
  const [richiesteCaricate, setRichiesteCaricate] = useState(false)
  const [richiestaSel, setRichiestaSel] = useState(null)
  const [filtroRichieste, setFiltroRichieste] = useState('aperta') // 'tutte' | 'aperta' | 'completata'
  const [rispostaText, setRispostaText] = useState('')
  const [nuovoStatoRich, setNuovoStatoRich] = useState('aperta')
  const [salvandoRisposta, setSalvandoRisposta] = useState(false)

  const CATEGORIE_EX = ['Tutte', 'Corpo libero', 'Calisthenics', 'Pesistica', 'Kettlebell', 'Cardio', 'Mobilità', 'CrossFit', 'Animal Flow']

  useEffect(() => { caricaUtenti() }, [])
  useEffect(() => { if (tab === 'esercizi') caricaEsercizi() }, [tab])
  useEffect(() => { if (tab === 'richieste') caricaRichieste() }, [tab])
  useEffect(() => { if (tab === 'contenuti' && !contenutiCaricati) caricaContenuti() }, [tab])
  useEffect(() => { if (tab === 'coach' && !gruppiCaricati && utenti.length > 0) caricaGruppiCoach() }, [tab, utenti])

  async function caricaEsercizi() {
    const { data } = await supabase.from('esercizi_db').select('id, nome, categoria, varianti, regressioni').order('nome')
    setEsercizi(data || [])
  }

  async function caricaGruppiCoach() {
    const coach = utenti.filter(u => u.piano === 'coach')
    const risultati = []
    for (const c of coach) {
      const { data: gruppi } = await supabase
        .from('gruppi')
        .select('id, nome, descrizione, gruppo_membri(utente_id)')
        .eq('gestore_id', c.id)
        .order('nome')

      // Arricchisce i membri con i dati già in memoria (utenti caricati da get-all-profiles)
      const gruppiArricchiti = (gruppi || []).map(g => ({
        ...g,
        gruppo_membri: (g.gruppo_membri || []).map(m => {
          const profilo = utenti.find(u => u.id === m.utente_id)
          return profilo ? { utente_id: m.utente_id, profili: profilo } : null
        }).filter(Boolean)
      }))

      risultati.push({ coach: c, gruppi: gruppiArricchiti })
    }
    setGruppiCoach(risultati)
    setGruppiCaricati(true)
  }

  async function rimuoviAtletaDaGruppo(gruppoId, atletaId, atletaNome) {
    if (!window.confirm(`Rimuovere ${atletaNome} dal gruppo?`)) return
    const { error } = await supabase
      .from('gruppo_membri')
      .delete()
      .eq('gruppo_id', gruppoId)
      .eq('utente_id', atletaId)
    if (error) { toast_msg('Errore: ' + error.message); return }
    toast_msg('✓ Atleta rimosso')
    setGruppiCaricati(false)
    caricaGruppiCoach()
  }

  async function eliminaGruppo(gruppoId, nomeGruppo) {
    if (!window.confirm(`Eliminare il gruppo "${nomeGruppo}" e tutti i suoi membri?`)) return
    await supabase.from('gruppo_membri').delete().eq('gruppo_id', gruppoId)
    const { error } = await supabase.from('gruppi').delete().eq('id', gruppoId)
    if (error) { toast_msg('Errore: ' + error.message); return }
    toast_msg('✓ Gruppo eliminato')
    setGruppiCaricati(false)
    caricaGruppiCoach()
  }

  async function caricaContenuti() {
    const { data } = await supabase
      .from('impostazioni_app')
      .select('chiave, valore')
      .in('chiave', ['guida', 'privacy', 'tos', 'manutenzione'])
    if (data) {
      const obj = {}
      data.forEach(r => { obj[r.chiave] = r.valore })
      setContenutiState(prev => ({ ...prev, ...obj }))
      if (obj.manutenzione) {
        try {
          const m = JSON.parse(obj.manutenzione)
          setManutenzione({ attiva: m.attiva || false, messaggio: m.messaggio || '' })
        } catch {}
      }
    }
    setContenutiCaricati(true)
  }

  async function salvaManutenzione(attiva, messaggio) {
    setSalvandoManutenzione(true)
    const valore = JSON.stringify({ attiva, messaggio })
    const { error } = await supabase
      .from('impostazioni_app')
      .upsert({ chiave: 'manutenzione', valore, aggiornato_il: new Date().toISOString() })
    setSalvandoManutenzione(false)
    if (error) { toast_msg('Errore: ' + error.message); return }
    setManutenzione({ attiva, messaggio })
    toast_msg(attiva ? '🔧 Manutenzione attivata' : '✓ App riattivata')
  }

  async function salvaContenuto(chiave, valore) {
    setSalvandoContenuti(true)
    const { error } = await supabase
      .from('impostazioni_app')
      .upsert({ chiave, valore, aggiornato_il: new Date().toISOString() })
    setSalvandoContenuti(false)
    if (error) { toast_msg('Errore: ' + error.message); return }
    toast_msg('✓ Contenuto salvato')
  }

  function apriModificaEsercizio(ex) {
    setEsercizioEdit(ex)
    setVariantiEdit(JSON.parse(JSON.stringify(comeLista(ex.varianti))))
    setRegressioniEdit(JSON.parse(JSON.stringify(comeLista(ex.regressioni))))
  }

  async function salvaVarianti() {
    const { error } = await supabase.from('esercizi_db')
      .update({ varianti: variantiEdit, regressioni: regressioniEdit })
      .eq('id', esercizioEdit.id)
    if (error) { toast_msg('Errore: ' + error.message); return }
    toast_msg('OK Varianti aggiornate!')
    setEsercizioEdit(null)
    caricaEsercizi()
  }

  // Helper: verifica sessione valida, se scaduta forza logout
  async function checkSession() {
    try {
      const { data: { session }, error } = await supabase.auth.getSession()
      if (error || !session?.access_token) {
        toast_msg('Sessione scaduta — effettua di nuovo il login')
        setTimeout(() => supabase.auth.signOut(), 1500)
        return null
      }
      return session
    } catch (e) {
      toast_msg('Sessione non valida — effettua di nuovo il login')
      setTimeout(() => supabase.auth.signOut(), 1500)
      return null
    }
  }

  async function eliminaEsercizio(id) {
    const session = await checkSession()
    if (!session) return
    setConfermaEliminaEx(null)
    toast_msg('⏳ Eliminazione in corso...')
    try {
      const { error } = await supabase.from('esercizi_db').delete().eq('id', id)
      if (error) { toast_msg('Errore: ' + error.message); return }
      toast_msg('✅ Esercizio eliminato')
      caricaEsercizi()
    } catch (e) {
      toast_msg('Errore imprevisto: ' + e.message)
    }
  }

  function aggiungiItem(lista, setLista) {
    setLista([...lista, { id: `v_${Date.now()}`, nome: '', livello: 5 }])
  }

  function rimuoviItem(lista, setLista, idx) {
    setLista(lista.filter((_, i) => i !== idx))
  }

  function aggiornaItem(lista, setLista, idx, campo, val) {
    setLista(lista.map((v, i) => i === idx ? { ...v, [campo]: campo === 'livello' ? +val : val } : v))
  }

  async function caricaUtenti() {
    setCaricamento(true)
    try {
      const { data: { session } } = await supabase.auth.getSession()
      const response = await fetch(
        funzioneUrl('get-all-profiles'),
        {
          headers: {
            'apikey': session?.access_token,
            'Authorization': `Bearer ${session?.access_token}`,
          },
        }
      )
      const result = await response.json()
      const lista = result.data || []
      setUtenti(lista)
    } catch (e) {
      console.error('Errore caricamento utenti:', e)
    }
    setCaricamento(false)
  }

  // Invia notifica in-app a un utente già iscritto
  async function inviaNotifica(utenteId, titolo, testo, tipo = 'info') {
    const { error } = await supabase.from('notifiche').insert({
      utente_id: utenteId,
      titolo,
      testo,
      tipo,
      letta: false,
    })
    if (error) console.error('inviaNotifica errore:', error.message, '— utente:', utenteId)
  }

  // ── RICHIESTE UTENTI ──
  async function caricaRichieste() {
    const { data, error } = await supabase.from('richieste_utente')
      .select('*').order('creata_il', { ascending: false })
    if (error) { toast_msg('Errore caricamento: ' + error.message); return }
    setRichiesteAdmin(data || [])
    setRichiesteCaricate(true)
  }

  function apriRichiesta(r) {
    setRichiestaSel(r)
    setNuovoStatoRich(r.stato)
    // Frase preimpostata se non c'è ancora una risposta
    if (!r.risposta_admin) {
      setRispostaText(`Grazie ${r.utente_nome || r.utente_email} per averci contattato.\n\n`)
    } else {
      setRispostaText(r.risposta_admin)
    }
  }

  async function rispondiRichiesta() {
    if (!richiestaSel) return
    setSalvandoRisposta(true)
    try {
      const { error } = await supabase.from('richieste_utente').update({
        risposta_admin: rispostaText.trim() || null,
        risposta_admin_id: profilo.id,
        stato: 'completata',  // chiude automaticamente la richiesta
      }).eq('id', richiestaSel.id)
      if (error) { toast_msg('Errore: ' + error.message); setSalvandoRisposta(false); return }

      // Notifica in-app all'utente
      const statoLabel = { aperta: 'in attesa', completata: 'completata' }['completata']
      await inviaNotifica(
        richiestaSel.utente_id,
        `💬 Risposta alla tua richiesta`,
        `"${richiestaSel.titolo}" è ora completata${rispostaText.trim() ? '. Apri per leggere la risposta.' : '.'}`,
        'risposta_richiesta'
      )

      // Email all'utente
      try {
        const { data: { session } } = await supabase.auth.getSession()
        if (!session?.access_token) {
          console.error('[risposta_richiesta] sessione non valida:', session)
        } else {
          const r = await fetch(funzioneUrl('send-gift-email'), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${session.access_token}` },
            body: JSON.stringify({
              tipo: 'risposta_richiesta',
              destinatario_email: richiestaSel.utente_email,
              destinatario_nome: richiestaSel.utente_nome,
              titolo_richiesta: richiestaSel.titolo,
              stato: 'completata',
              risposta_admin: rispostaText.trim(),
            }),
          })
          if (!r.ok) {
            const err = await r.json().catch(() => ({}))
            console.error('[risposta_richiesta] email errore:', r.status, err)
          } else {
          }
        }
      } catch (e) {
        console.error('[risposta_richiesta] email fetch errore:', e)
      }

      toast_msg('✅ Risposta inviata!')
      setRichiestaSel(null)
      setRispostaText('')
      setNuovoStatoRich('aperta')
      await caricaRichieste()
    } catch (e) {
      toast_msg('Errore: ' + e.message)
    }
    setSalvandoRisposta(false)
  }

  async function eliminaRichiestaAdmin(richiestaId) {
    const { error } = await supabase.from('richieste_utente').delete().eq('id', richiestaId)
    if (error) { toast_msg('Errore: ' + error.message); return }
    toast_msg('🗑️ Richiesta eliminata')
    setRichiestaSel(null)
    await caricaRichieste()
  }


  // Crea un gift token per un non-iscritto
  async function creaGiftToken() {
    if (!giftEmail.trim()) { toast_msg('Inserisci email destinatario'); return }
    const { data: { session } } = await supabase.auth.getSession()
    const { data, error } = await supabase.from('gift_tokens').insert({
      mittente_id: session.user.id,
      mittente_email: session.user.email,
      destinatario_email: giftEmail.trim().toLowerCase(),
      piano: giftPiano,
      mesi: giftMesi,
    }).select('token').single()
    if (error) { toast_msg('Errore: ' + error.message); return }
    const link = `https://fitprogress.it/registrati?gift=${data.token}`
    setGiftCreato({ token: data.token, link })

    // Invia email automatica
    const risultatoEmail = await inviaEmailGift(giftEmail.trim().toLowerCase(), link, giftPiano, giftMesi, session)
    if (risultatoEmail.ok) {
      toast_msg('✓ Gift creato e email inviata!')
    } else {
      toast_msg('✓ Gift creato — ' + (risultatoEmail.errore || 'email non inviata, usa il link'))
    }
  }

  async function inviaEmailGift(destinatario_email, link, piano, mesi, session) {
    try {
      const res = await fetch(funzioneUrl('send-gift-email'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${session.access_token}`,
        },
        body: JSON.stringify({
          destinatario_email,
          link,
          piano,
          mesi,
          mittente_nome: 'Il team FitProgress',
        }),
      })
      const body = await res.text()
      if (res.ok) return { ok: true }
      console.error('[inviaEmailGift] status:', res.status, 'body:', body)
      return { ok: false, errore: `Errore ${res.status}: ${body}` }
    } catch (e) {
      console.error('[inviaEmailGift] fetch error:', e)
      return { ok: false, errore: 'Connessione fallita: ' + e.message }
    }
  }

  function condividiGiftWhatsApp(link, piano, mesi) {
    const testo = `🎁 Ecco il tuo regalo FitProgress!\n\nTi è stato regalato un abbonamento ${piano} da ${mesi} ${mesi === 1 ? 'mese' : 'mesi'}.\n\nRegistrati qui per attivarlo:\n${link}`
    window.open(`https://wa.me/?text=${encodeURIComponent(testo)}`, '_blank')
  }

  async function regalaAbbonamento(metodo) {
    // metodo (solo per non iscritti): 'email' | 'whatsapp' | 'copia'
    if (!emailRegalo.trim()) { toast_msg('Inserisci una email'); return }
    const email = emailRegalo.trim().toLowerCase()
    const utente = utenti.find(u => u.email.toLowerCase() === email)

    if (utente) {
      // ── ISCRITTO: attiva subito + notifica in-app ──
      const scadenza = new Date()
      scadenza.setMonth(scadenza.getMonth() + mesiRegalo)
      const result = await adminUpdate(utente.id, {
        piano: pianoRegalo,
        abbonamento_attivo: true,
        regalo: true,
        regalo_da: 'admin',
        abbonamento_dal: new Date().toISOString(),
        abbonamento_al: scadenza.toISOString(),
      })
      if (result.error) { toast_msg('Errore: ' + result.error); return }
      const durata = mesiRegalo === 12 ? '1 anno' : `${mesiRegalo} ${mesiRegalo === 1 ? 'mese' : 'mesi'}`
      await inviaNotifica(
        utente.id,
        '🎁 Hai ricevuto un abbonamento in regalo!',
        `Il tuo abbonamento ${pianoRegalo} da ${durata} è stato attivato dall'amministratore. Scadenza: ${scadenza.toLocaleDateString('it-IT', { day: 'numeric', month: 'long', year: 'numeric' })}. Buon allenamento! 💪`,
        'regalo'
      )
      toast_msg(`✓ Abbonamento ${pianoRegalo} (${durata}) attivato per ${utente.nome}!`)
      setEmailRegalo('')
      setRegaloCreato(null)
      caricaUtenti()
    } else {
      // ── NON ISCRITTO: crea gift token e invia con metodo scelto ──
      const { data: { session } } = await supabase.auth.getSession()
      const { data, error } = await supabase.from('gift_tokens').insert({
        mittente_id: session.user.id,
        mittente_email: session.user.email,
        destinatario_email: email,
        piano: pianoRegalo,
        mesi: mesiRegalo,
      }).select('token').single()
      if (error) { toast_msg('Errore creazione gift: ' + error.message); return }
      const link = `https://fitprogress.it/?gift=${data.token}`
      const durata = mesiRegalo === 12 ? '1 anno' : `${mesiRegalo} ${mesiRegalo === 1 ? 'mese' : 'mesi'}`
      const testoWA = `🎁 Ecco il tuo regalo FitProgress!\n\nTi è stato regalato un abbonamento ${pianoRegalo} da ${durata}.\n\nRegistrati qui per attivarlo:\n${link}`

      if (metodo === 'email') {
        setEmailInviataStato('invio')
        const risultato = await inviaEmailGift(email, link, pianoRegalo, mesiRegalo, session)
        if (risultato.ok) {
          setEmailInviataStato('ok')
        } else {
          setEmailInviataStato('errore')
          toast_msg(`⚠ Email non inviata: ${risultato.errore || 'errore sconosciuto'}`)
        }
      } else if (metodo === 'whatsapp') {
        window.open(`https://wa.me/?text=${encodeURIComponent(testoWA)}`, '_blank')
        toast_msg('✓ WhatsApp aperto!')
      } else if (metodo === 'copia') {
        navigator.clipboard.writeText(link)
        toast_msg('✓ Link copiato!')
      }
      setRegaloCreato({ link, email, piano: pianoRegalo, mesi: mesiRegalo })
    }
  }

  async function revocaregalo(utenteId) {
    if (!window.confirm('Revocare l\'abbonamento regalato?')) return
    await adminUpdate(utenteId, { abbonamento_attivo: false, regalo: false })
    await inviaNotifica(
      utenteId,
      'Abbonamento terminato',
      'Il tuo abbonamento in regalo è stato revocato dall\'amministratore. Contatta il supporto per maggiori informazioni.',
      'info'
    )
    toast_msg('Abbonamento revocato')
    caricaUtenti()
  }

  function toast_msg(msg) { setToast(msg); setTimeout(() => setToast(''), 2500) }

  async function adminUpdate(targetId, updates) {
    const { data: { session } } = await supabase.auth.getSession()
    const response = await fetch(
      funzioneUrl('admin-update-profile'),
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'apikey': process.env.REACT_APP_SUPABASE_ANON_KEY,
          'Authorization': `Bearer ${session?.access_token}`,
        },
        body: JSON.stringify({ targetId, updates }),
      }
    )
    return response.json()
  }

  async function cambiaPianoUtente(u, nuovoPiano) {
    setSalvando(true)
    const res = await adminUpdate(u.id, { piano: nuovoPiano }, 'cambio_piano')
    setSalvando(false)
    if (res.error) { toast_msg('Errore: ' + res.error); return }
    toast_msg(`✓ Piano cambiato a ${nuovoPiano}`)
    setUtenteSel(prev => prev ? { ...prev, piano: nuovoPiano } : null)
    setUtenti(prev => prev.map(u2 => u2.id === u.id ? { ...u2, piano: nuovoPiano } : u2))
  }

  async function bloccaSbloccaUtente(u, bloccato, motivo) {
    setSalvando(true)
    const res = await adminUpdate(u.id, {
      bloccato,
      bloccato_motivo: bloccato ? (motivo || null) : null,
    }, bloccato ? 'blocca' : 'sblocca')
    setSalvando(false)
    if (res.error) { toast_msg('Errore: ' + res.error); return }
    toast_msg(bloccato ? '✓ Utente bloccato' : '✓ Utente sbloccato')
    setMotivoBlocco('')
    const aggiornamenti = { bloccato, bloccato_motivo: bloccato ? motivo : null }
    setUtenteSel(prev => prev ? { ...prev, ...aggiornamenti } : null)
    setUtenti(prev => prev.map(u2 => u2.id === u.id ? { ...u2, ...aggiornamenti } : u2))
  }

  async function salvaNoteAdmin(u, note) {
    setSalvando(true)
    const res = await adminUpdate(u.id, { note_admin: note }, 'note_admin')
    setSalvando(false)
    if (res.error) { toast_msg('Errore: ' + res.error); return }
    toast_msg('✓ Note salvate')
    setUtenteSel(prev => prev ? { ...prev, note_admin: note } : null)
    setUtenti(prev => prev.map(u2 => u2.id === u.id ? { ...u2, note_admin: note } : u2))
  }

  async function cancellaUtente(u) {
    if (emailConferma.trim().toLowerCase() !== u.email.toLowerCase()) {
      toast_msg('Email di conferma non corrisponde')
      return
    }
    setSalvando(true)
    try {
      const { data: { session } } = await supabase.auth.getSession()
      const response = await fetch(
        funzioneUrl('delete-user'),
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'apikey': process.env.REACT_APP_SUPABASE_ANON_KEY,
            'Authorization': `Bearer ${session?.access_token}`,
          },
          body: JSON.stringify({ targetId: u.id, confermaEmail: emailConferma.trim() })
        }
      )
      const result = await response.json()
      if (!response.ok) { toast_msg('Errore: ' + (result.error || 'sconosciuto')); setSalvando(false); return }
      toast_msg(`✓ Utente ${u.email} cancellato`)
      setConfermaElimina(null)
      setEmailConferma('')
      setUtenteSel(null)
      caricaUtenti()
    } catch (e) {
      toast_msg('Errore: ' + e.message)
    }
    setSalvando(false)
  }

  function apriUtente(u) {
    setUtenteSel(u)
    setNoteAdmin(u.note_admin || '')
    setMotivoBlocco(u.bloccato_motivo || '')
  }

  const ora = new Date()
  const atleti = utenti.filter(u => u.piano === 'atleta')
  const coachFree = utenti.filter(u => u.piano === 'coach' && !u.abbonamento_attivo && !u.regalo)
  const regalati = utenti.filter(u => u.regalo)
  const abbonati = utenti.filter(u => u.abbonamento_attivo && !u.regalo && u.piano !== 'admin')

  const formatData = (d) => d ? new Date(d).toLocaleDateString('it-IT', { day: 'numeric', month: 'short', year: 'numeric' }) : ''

  const PIANO_COLOR = {
    atleta: { bg: 'rgba(87,184,255,0.15)', text: 'var(--accent2)' },
    coach: { bg: 'rgba(127,214,61,0.15)', text: 'var(--accent)' },
    admin: { bg: 'rgba(199,125,255,0.15)', text: 'var(--purple)' },
  }

  // Vista modifica varianti esercizio
  if (esercizioEdit) return (
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }} className="fade-in">
      <div className="topbar">
        <button className="back-btn" onClick={() => setEsercizioEdit(null)}>&larr;</button>
        <div style={{ fontFamily: 'Syne', fontWeight: 700, fontSize: 14, flex: 1, textAlign: 'center' }}>{esercizioEdit.nome}</div>
        <button className="btn btn-primary btn-sm" onClick={salvaVarianti}>Salva</button>
      </div>

      <div className="scroll-area">

        {/* Info esercizio */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
          <span style={{
            fontSize: 11, fontWeight: 700, padding: '3px 10px', borderRadius: 10,
            background: esercizioEdit.categoria === 'Calisthenics' ? 'rgba(179,92,0,0.15)' :
                        esercizioEdit.categoria === 'Pesistica' ? 'rgba(87,184,255,0.15)' :
                        esercizioEdit.categoria === 'Corpo libero' ? 'rgba(74,222,128,0.15)' :
                        esercizioEdit.categoria === 'Kettlebell' ? 'rgba(199,125,255,0.15)' : 'rgba(255,255,255,0.08)',
            color: esercizioEdit.categoria === 'Calisthenics' ? 'var(--yellow)' :
                   esercizioEdit.categoria === 'Pesistica' ? 'var(--accent2)' :
                   esercizioEdit.categoria === 'Corpo libero' ? 'var(--green)' :
                   esercizioEdit.categoria === 'Kettlebell' ? 'var(--purple)' : 'var(--muted)',
          }}>{esercizioEdit.categoria}</span>
        </div>

        {/* VARIANTI */}
        <div className="card">
          <div className="card-header">
            <div className="card-title">↑ Varianti più difficili</div>
            <button className="btn btn-primary btn-sm" onClick={() => aggiungiItem(variantiEdit, setVariantiEdit)}>+ Aggiungi</button>
          </div>
          <div className="card-body" style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {variantiEdit.length === 0 ? (
              <div style={{ fontSize: 13, color: 'var(--muted)', textAlign: 'center', padding: '8px 0' }}>
                Nessuna variante — clicca "+ Aggiungi" per aggiungerne una
              </div>
            ) : variantiEdit.map((v, i) => (
              <div key={v.id} style={{
                display: 'flex', gap: 8, alignItems: 'center',
                background: 'var(--surface2)', borderRadius: 10, padding: '10px 12px',
                border: '1px solid var(--border)',
              }}>
                <div style={{ flex: 1, fontWeight: 600, fontSize: 12, color: 'var(--accent)', minWidth: 16 }}>{i + 1}</div>
                <input
                  className="form-input"
                  value={v.nome}
                  onChange={e => aggiornaItem(variantiEdit, setVariantiEdit, i, 'nome', e.target.value)}
                  placeholder="Nome variante"
                  style={{ flex: 3, fontSize: 13, padding: '8px 10px' }}
                />
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, flexShrink: 0 }}>
                  <input
                    className="num-input"
                    type="number" min={1} max={10}
                    value={v.livello}
                    onChange={e => aggiornaItem(variantiEdit, setVariantiEdit, i, 'livello', e.target.value)}
                    style={{ fontSize: 14, width: 52, padding: '6px 4px' }}
                  />
                  <div style={{ fontSize: 9, color: 'var(--muted)', letterSpacing: 0.5 }}>LV</div>
                </div>
                <button
                  onClick={() => rimuoviItem(variantiEdit, setVariantiEdit, i)}
                  style={{ background: 'rgba(248,113,113,0.1)', border: '1px solid rgba(248,113,113,0.3)', borderRadius: 8, width: 32, height: 32, display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--red)', cursor: 'pointer', fontSize: 16, flexShrink: 0 }}
                >×</button>
              </div>
            ))}
          </div>
        </div>

        {/* REGRESSIONI */}
        <div className="card">
          <div className="card-header">
            <div className="card-title">↓ Regressioni più facili</div>
            <button className="btn btn-primary btn-sm" onClick={() => aggiungiItem(regressioniEdit, setRegressioniEdit)}>+ Aggiungi</button>
          </div>
          <div className="card-body" style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {regressioniEdit.length === 0 ? (
              <div style={{ fontSize: 13, color: 'var(--muted)', textAlign: 'center', padding: '8px 0' }}>
                Nessuna regressione — clicca "+ Aggiungi" per aggiungerne una
              </div>
            ) : regressioniEdit.map((v, i) => (
              <div key={v.id} style={{
                display: 'flex', gap: 8, alignItems: 'center',
                background: 'var(--surface2)', borderRadius: 10, padding: '10px 12px',
                border: '1px solid var(--border)',
              }}>
                <div style={{ flex: 1, fontWeight: 600, fontSize: 12, color: 'var(--accent2)', minWidth: 16 }}>{i + 1}</div>
                <input
                  className="form-input"
                  value={v.nome}
                  onChange={e => aggiornaItem(regressioniEdit, setRegressioniEdit, i, 'nome', e.target.value)}
                  placeholder="Nome regressione"
                  style={{ flex: 3, fontSize: 13, padding: '8px 10px' }}
                />
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, flexShrink: 0 }}>
                  <input
                    className="num-input"
                    type="number" min={1} max={10}
                    value={v.livello}
                    onChange={e => aggiornaItem(regressioniEdit, setRegressioniEdit, i, 'livello', e.target.value)}
                    style={{ fontSize: 14, width: 52, padding: '6px 4px' }}
                  />
                  <div style={{ fontSize: 9, color: 'var(--muted)', letterSpacing: 0.5 }}>LV</div>
                </div>
                <button
                  onClick={() => rimuoviItem(regressioniEdit, setRegressioniEdit, i)}
                  style={{ background: 'rgba(248,113,113,0.1)', border: '1px solid rgba(248,113,113,0.3)', borderRadius: 8, width: 32, height: 32, display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--red)', cursor: 'pointer', fontSize: 16, flexShrink: 0 }}
                >×</button>
              </div>
            ))}
          </div>
        </div>

        {/* Salva */}
        <button className="btn btn-primary" onClick={salvaVarianti}>Salva modifiche</button>

        {/* Zona pericolosa */}
        <div style={{ borderTop: '1px solid var(--border)', paddingTop: 16, marginTop: 4 }}>
          <div style={{ fontSize: 11, fontWeight: 700, color: 'var(--red)', letterSpacing: 1, textTransform: 'uppercase', marginBottom: 10 }}>Zona pericolosa</div>
          <button
            className="btn btn-danger"
            onClick={() => { setConfermaEliminaEx(esercizioEdit); setEsercizioEdit(null) }}
          >
            🗑 Elimina esercizio dal database
          </button>
        </div>

      </div>
      {toast && <div className="toast">{toast}</div>}
    </div>
  )

  async function navigaDaNotifica(dest, richiestaId) {
    if (dest === 'richieste') {
      setTab('richieste')
      setMostraNotifiche(false)
      if (richiestaId) {
        // Aspetta un tick per il re-render, poi carica e apri la richiesta
        const { data } = await supabase.from('richieste_utente').select('*').eq('id', richiestaId).single()
        await caricaRichieste()
        if (data) {
          // Piccolo delay per assicurare che il rendering del tab sia avvenuto
          setTimeout(() => apriRichiesta(data), 50)
        }
      }
    } else {
      setMostraNotifiche(false)
    }
  }

  if (mostraNotifiche) return <PaginaNotifiche onChiudi={() => setMostraNotifiche(false)} onNavigate={navigaDaNotifica} />

  return (
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }} className="fade-in">
      <TopBar onNotifiche={() => setMostraNotifiche(true)} />

      {/* Stats rapide */}
      <div style={{ padding: '12px 20px', display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: 8 }}>
        {[
          { label: 'Atleti', val: atleti.length, color: 'var(--green)' },
          { label: 'Coach Free', val: coachFree.length, color: 'var(--muted)' },
          { label: 'Regalati', val: regalati.length, color: 'var(--purple)' },
          { label: 'Abbonati', val: abbonati.length, color: 'var(--accent2)' },
        ].map(s => (
          <div key={s.label} style={{ background: 'var(--surface)', borderRadius: 10, padding: '10px 8px', textAlign: 'center', border: '1px solid var(--border)' }}>
            <div style={{ fontFamily: 'Syne', fontWeight: 800, fontSize: 22, color: s.color }}>{s.val}</div>
            <div style={{ fontSize: 9, color: 'var(--muted)', marginTop: 2 }}>{s.label}</div>
          </div>
        ))}
      </div>

      {/* Tab — riga 1 */}
      <div style={{ borderBottom: '1px solid var(--border)', padding: '0 20px' }}>
        <div style={{ display: 'flex' }}>
          {[
            { id: 'iscritti', label: `Iscritti (${utenti.filter(u => u.piano !== 'admin').length})` },
            { id: 'coach', label: `Coach (${utenti.filter(u => u.piano === 'coach').length})` },
            { id: 'regalati', label: `Regalati (${regalati.length})` },
          ].map(t => (
            <button key={t.id} onClick={() => setTab(t.id)} style={{ flex: 1, padding: '12px 4px', background: 'none', border: 'none', borderBottom: `2px solid ${tab === t.id ? 'var(--accent)' : 'transparent'}`, color: tab === t.id ? 'var(--accent)' : 'var(--muted)', fontWeight: 700, fontSize: 11, cursor: 'pointer', fontFamily: 'Syne', textAlign: 'center' }}>{t.label}</button>
          ))}
        </div>
        {/* Tab — riga 2 */}
        <div style={{ display: 'flex' }}>
          {[
            { id: 'abbonati', label: `Abbonati (${abbonati.length})` },
            { id: 'regala', label: '+ Regala' },
            { id: 'richieste', label: `📩 Richieste${richiesteAdmin.filter(r => r.stato === 'aperta').length > 0 ? ` (${richiesteAdmin.filter(r => r.stato === 'aperta').length})` : ''}` },
            { id: 'esercizi', label: '💪 Esercizi' },
            { id: 'contenuti', label: '📝 Testi' },
            { id: 'sponsor', label: '🏷️ Sponsor' },
          ].map(t => (
            <button key={t.id} onClick={() => setTab(t.id)} style={{ flex: 1, padding: '12px 4px', background: 'none', border: 'none', borderBottom: `2px solid ${tab === t.id ? 'var(--accent)' : 'transparent'}`, color: tab === t.id ? 'var(--accent)' : 'var(--muted)', fontWeight: 700, fontSize: 11, cursor: 'pointer', fontFamily: 'Syne', textAlign: 'center' }}>{t.label}</button>
          ))}
        </div>
      </div>

      <div className="scroll-area">
        {caricamento && tab !== 'esercizi' ? (
          <div style={{ textAlign: 'center', color: 'var(--muted)', padding: 40 }}>Caricamento...</div>
        ) : <>

          {/* ══ VISTA COACH + GRUPPI ══ */}
          {tab === 'coach' && (() => {
            const coach = utenti.filter(u => u.piano === 'coach')
            if (coach.length === 0) return (
              <div style={{ textAlign: 'center', color: 'var(--muted)', padding: 40, fontSize: 13 }}>Nessun coach registrato</div>
            )
            if (!gruppiCaricati) return (
              <div style={{ textAlign: 'center', color: 'var(--muted)', padding: 40 }}>Caricamento gruppi...</div>
            )
            return (
              <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                {gruppiCoach.map(({ coach: c, gruppi }) => {
                  const totaleAtleti = gruppi.reduce((acc, g) => acc + (g.gruppo_membri || []).filter(m => m.profili).length, 0)
                  const isAperto = coachAperto === c.id
                  return (
                    <div key={c.id} className="card">
                      {/* Header coach — clicca per espandere */}
                      <div className="card-body" style={{ cursor: 'pointer' }}
                        onClick={() => setCoachAperto(isAperto ? null : c.id)}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                          <div>
                            <div style={{ fontFamily: 'Syne', fontWeight: 700, fontSize: 14 }}>{c.nome} {c.cognome}</div>
                            <div style={{ fontSize: 11, color: 'var(--muted)', marginTop: 2 }}>{c.email}</div>
                            <div style={{ fontSize: 11, color: 'var(--accent)', marginTop: 4 }}>
                              {gruppi.length} {gruppi.length === 1 ? 'gruppo' : 'gruppi'} · {totaleAtleti} {totaleAtleti === 1 ? 'atleta' : 'atleti'}
                            </div>
                          </div>
                          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                            <button onClick={e => { e.stopPropagation(); apriUtente(c) }}
                              style={{ background: 'none', border: '1px solid var(--border)', borderRadius: 8, padding: '5px 10px', color: 'var(--accent)', cursor: 'pointer', fontSize: 11, fontWeight: 700 }}>
                              Gestisci
                            </button>
                            <span style={{ fontSize: 16, color: 'var(--muted)', transform: isAperto ? 'rotate(180deg)' : 'none', transition: 'transform 0.2s' }}>▾</span>
                          </div>
                        </div>
                      </div>

                      {/* Gruppi espansi */}
                      {isAperto && (
                        <div style={{ borderTop: '1px solid var(--border)' }}>
                          {gruppi.length === 0 ? (
                            <div style={{ padding: '12px 16px', fontSize: 12, color: 'var(--muted)' }}>Nessun gruppo creato</div>
                          ) : gruppi.map(g => {
                            const membri = (g.gruppo_membri || []).filter(m => m.profili)
                            return (
                              <div key={g.id} style={{ borderBottom: '1px solid var(--border)', padding: '12px 16px' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                                  <div>
                                    <div style={{ fontWeight: 700, fontSize: 13 }}>📋 {g.nome}</div>
                                    {g.descrizione && <div style={{ fontSize: 11, color: 'var(--muted)', marginTop: 2 }}>{g.descrizione}</div>}
                                    <div style={{ fontSize: 11, color: 'var(--muted)', marginTop: 2 }}>{membri.length} {membri.length === 1 ? 'atleta' : 'atleti'}</div>
                                  </div>
                                  <button onClick={() => eliminaGruppo(g.id, g.nome)}
                                    style={{ background: 'none', border: '1px solid rgba(248,113,113,0.3)', borderRadius: 6, padding: '4px 10px', color: 'var(--red)', cursor: 'pointer', fontSize: 11, fontWeight: 700, flexShrink: 0 }}>
                                    Elimina gruppo
                                  </button>
                                </div>
                                {membri.length === 0 ? (
                                  <div style={{ fontSize: 11, color: 'var(--muted)' }}>Nessun atleta nel gruppo</div>
                                ) : membri.map(m => (
                                  <div key={m.utente_id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '7px 0', borderTop: '1px solid var(--border)' }}>
                                    <div>
                                      <div style={{ fontSize: 12, fontWeight: 600 }}>{m.profili.nome} {m.profili.cognome}</div>
                                      <div style={{ fontSize: 10, color: 'var(--muted)' }}>{m.profili.email}</div>
                                    </div>
                                    <button onClick={() => rimuoviAtletaDaGruppo(g.id, m.utente_id, `${m.profili.nome} ${m.profili.cognome}`)}
                                      style={{ background: 'none', border: 'none', color: 'var(--red)', cursor: 'pointer', fontSize: 20, padding: '0 4px', lineHeight: 1 }}>
                                      ×
                                    </button>
                                  </div>
                                ))}
                              </div>
                            )
                          })}
                        </div>
                      )}
                    </div>
                  )
                })}
              </div>
            )
          })()}

          {/* ABBONAMENTI REGALATI */}
          {tab === 'regalati' && (() => {
            if (regalati.length === 0) return (
              <div style={{ textAlign: 'center', color: 'var(--muted)', padding: 40, fontSize: 13 }}>Nessun abbonamento regalato</div>
            )
            // Distingui regalati dall'admin (regalo_da è null o email admin) vs regalati da altri utenti
            const adminEmail = utenti.find(u => u.piano === 'admin')?.email
            const regalatiDaAdmin = regalati.filter(u => !u.regalo_da || u.regalo_da === adminEmail)
            const regalatiDaUtenti = regalati.filter(u => u.regalo_da && u.regalo_da !== adminEmail)

            const renderRegalato = (u) => {
              const mittente = u.regalo_da
                ? utenti.find(x => x.email === u.regalo_da) || { nome: u.regalo_da, cognome: '' }
                : null
              return (
                <div key={u.id} className="card" onClick={() => apriUtente(u)} style={{ cursor: 'pointer' }}>
                  <div className="card-body" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    <div>
                      <div style={{ fontWeight: 600, fontSize: 13 }}>{u.nome} {u.cognome}</div>
                      <div style={{ fontSize: 11, color: 'var(--muted)', marginTop: 2 }}>{u.email}</div>
                      <div style={{ fontSize: 11, color: 'var(--green)', marginTop: 4 }}>
                        Regalo dal {formatData(u.abbonamento_dal)}
                      </div>
                      {mittente && (
                        <div style={{ fontSize: 11, color: 'var(--purple)', marginTop: 2 }}>
                          Da: {mittente.nome} {mittente.cognome}
                        </div>
                      )}
                      {u.abbonamento_al && (
                        <div style={{ fontSize: 11, color: new Date(u.abbonamento_al) > new Date() ? 'var(--accent)' : 'var(--red)', marginTop: 2 }}>
                          Scade: {formatData(u.abbonamento_al)}
                        </div>
                      )}
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 6 }}>
                      <span className="badge" style={{ background: PIANO_COLOR[u.piano]?.bg, color: PIANO_COLOR[u.piano]?.text }}>{u.piano}</span>
                      <button onClick={(e) => { e.stopPropagation(); revocaregalo(u.id) }}
                        style={{ background: 'none', border: '1px solid rgba(248,113,113,0.3)', borderRadius: 6, padding: '3px 8px', color: 'var(--red)', cursor: 'pointer', fontSize: 10, fontWeight: 700 }}>
                        Revoca
                      </button>
                    </div>
                  </div>
                </div>
              )
            }

            return <>
              {regalatiDaAdmin.length > 0 && <>
                <div style={{ fontSize: 10, fontWeight: 700, color: 'var(--purple)', letterSpacing: 1.5, textTransform: 'uppercase', padding: '4px 0' }}>
                  🛡️ Regalati dall'admin ({regalatiDaAdmin.length})
                </div>
                {regalatiDaAdmin.map(renderRegalato)}
              </>}
              {regalatiDaUtenti.length > 0 && <>
                <div style={{ fontSize: 10, fontWeight: 700, color: 'var(--accent2)', letterSpacing: 1.5, textTransform: 'uppercase', padding: '4px 0', marginTop: regalatiDaAdmin.length > 0 ? 12 : 0 }}>
                  👥 Regalati da altri utenti ({regalatiDaUtenti.length})
                </div>
                {regalatiDaUtenti.map(renderRegalato)}
              </>}
            </>
          })()}

          {/* ABBONATI PAGANTI */}
          {tab === 'abbonati' && (() => {
            const coach = abbonati.filter(u => u.piano === 'coach')
            const atleti = abbonati.filter(u => u.piano === 'atleta')
            if (abbonati.length === 0) return (
              <div style={{ textAlign: 'center', color: 'var(--muted)', padding: 40, fontSize: 13 }}>Nessun abbonato pagante</div>
            )
            const renderUtente = (u) => (
              <div key={u.id} className="card" onClick={() => apriUtente(u)} style={{ cursor: 'pointer' }}>
                <div className="card-body" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div>
                    <div style={{ fontWeight: 600, fontSize: 13 }}>{u.nome} {u.cognome}</div>
                    <div style={{ fontSize: 11, color: 'var(--muted)', marginTop: 2 }}>{u.email}</div>
                    <div style={{ fontSize: 11, color: 'var(--accent2)', marginTop: 4 }}>Dal {formatData(u.abbonamento_dal)}</div>
                  </div>
                  <span className="badge" style={{ background: PIANO_COLOR[u.piano]?.bg, color: PIANO_COLOR[u.piano]?.text }}>{u.piano}</span>
                </div>
              </div>
            )
            return <>
              {coach.length > 0 && <>
                <div style={{ fontSize: 10, fontWeight: 700, color: 'var(--accent)', letterSpacing: 1.5, textTransform: 'uppercase', padding: '4px 0' }}>
                   Coach ({coach.length})
                </div>
                {coach.map(renderUtente)}
              </>}
              {atleti.length > 0 && <>
                <div style={{ fontSize: 10, fontWeight: 700, color: 'var(--accent2)', letterSpacing: 1.5, textTransform: 'uppercase', padding: '4px 0', marginTop: coach.length > 0 ? 12 : 0 }}>
                   Atleti ({atleti.length})
                </div>
                {atleti.map(renderUtente)}
              </>}
            </>
          })()}

          {/* REGALA ABBONAMENTO */}
          {tab === 'regala' && (
            <div className="card slide-up">
              <div className="card-header"><div className="card-title">🎁 Regala abbonamento</div></div>
              <div className="card-body" style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>

                <div className="form-group">
                  <label className="form-label">Email destinatario</label>
                  <input className="form-input" type="email" value={emailRegalo}
                    onChange={e => { setEmailRegalo(e.target.value); setRegaloCreato(null); setEmailInviataStato(null) }}
                    placeholder="utente@email.com" />
                  {emailRegalo.trim() && (() => {
                    const trovato = utenti.find(u => u.email.toLowerCase() === emailRegalo.trim().toLowerCase())
                    return (
                      <div style={{ fontSize: 11, marginTop: 4, color: trovato ? 'var(--accent)' : '#fbbf24' }}>
                        {trovato
                          ? `✓ Iscritto: ${trovato.nome} ${trovato.cognome || ''} · piano attuale: ${trovato.piano}`
                          : '⚠ Non iscritto — riceverà un link per registrarsi'}
                      </div>
                    )
                  })()}
                </div>

                <div className="form-group">
                  <label className="form-label">Piano</label>
                  <div style={{ padding: '12px', borderRadius: 10, border: `2px solid ${PIANO_COLOR.coach?.text}`, background: PIANO_COLOR.coach?.bg, fontFamily: 'Syne', fontWeight: 700, fontSize: 13, color: PIANO_COLOR.coach?.text, textAlign: 'center' }}>
                    👨‍🏫 Coach Premium
                  </div>
                  <div style={{ fontSize: 11, color: 'var(--muted)', marginTop: 6 }}>L'Atleta è sempre gratuito — non c'è un abbonamento da regalare su quel piano.</div>
                </div>

                <div className="form-group">
                  <label className="form-label">Durata</label>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: 6 }}>
                    {[1, 2, 3, 12].map(m => (
                      <button key={m} type="button" onClick={() => setMesiRegalo(m)}
                        style={{ padding: '10px 4px', borderRadius: 10,
                          border: `2px solid ${mesiRegalo === m ? 'var(--accent)' : 'var(--border)'}`,
                          background: mesiRegalo === m ? 'rgba(127,214,61,0.15)' : 'var(--surface2)',
                          cursor: 'pointer', fontFamily: 'Syne', fontWeight: 700, fontSize: 12,
                          color: mesiRegalo === m ? 'var(--accent)' : 'var(--muted)' }}>
                        {m === 12 ? '1 anno' : `${m} ${m === 1 ? 'mese' : 'mesi'}`}
                      </button>
                    ))}
                  </div>
                </div>

                {/* Pulsanti di invio — cambiano in base a iscritto o no */}
                {emailRegalo.trim() && (() => {
                  const trovato = utenti.find(u => u.email.toLowerCase() === emailRegalo.trim().toLowerCase())
                  if (trovato) {
                    // Iscritto: un solo pulsante, attiva e notifica in-app
                    return (
                      <button className="btn btn-primary" onClick={() => regalaAbbonamento(null)}
                        disabled={!emailRegalo.trim()}>
                        🎁 Attiva abbonamento e invia notifica in-app
                      </button>
                    )
                  } else {
                    // Non iscritto: tre pulsanti di invio
                    return (
                      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                        <div style={{ fontSize: 12, color: 'var(--muted)', textAlign: 'center', padding: '4px 0' }}>
                          Scegli come inviare il link di registrazione:
                        </div>
                        <button className="btn btn-primary"
                          onClick={() => { if (emailInviataStato !== 'invio') { setEmailInviataStato(null); regalaAbbonamento('email') } }}
                          disabled={emailInviataStato === 'invio'}
                          style={{
                            background: emailInviataStato === 'ok' ? 'rgba(74,222,128,0.2)' : emailInviataStato === 'errore' ? 'rgba(248,113,113,0.2)' : undefined,
                            border: emailInviataStato === 'ok' ? '2px solid rgba(74,222,128,0.6)' : emailInviataStato === 'errore' ? '2px solid rgba(248,113,113,0.6)' : undefined,
                            color: emailInviataStato === 'ok' ? '#4ade80' : emailInviataStato === 'errore' ? '#f87171' : undefined,
                            cursor: emailInviataStato === 'invio' ? 'wait' : 'pointer',
                          }}>
                          {emailInviataStato === 'invio' ? '⏳ Invio in corso...' : emailInviataStato === 'ok' ? '✓ Email inviata!' : emailInviataStato === 'errore' ? '⚠ Errore — riprova' : '📧 Invia email'}
                        </button>
                        {emailInviataStato === 'ok' && (
                          <div style={{ display: 'flex', alignItems: 'center', gap: 8, background: 'rgba(74,222,128,0.1)', border: '1px solid rgba(74,222,128,0.3)', borderRadius: 10, padding: '10px 14px' }}>
                            <span style={{ fontSize: 18 }}>✅</span>
                            <div>
                              <div style={{ fontSize: 13, fontWeight: 700, color: '#4ade80' }}>Email inviata con successo!</div>
                              <div style={{ fontSize: 11, color: 'var(--muted)', marginTop: 2 }}>Il destinatario riceverà il link per attivare l'abbonamento.</div>
                            </div>
                          </div>
                        )}
                        <button className="btn btn-secondary" onClick={() => regalaAbbonamento('whatsapp')}>
                          📲 Invia su WhatsApp
                        </button>
                        <button className="btn btn-ghost" onClick={() => regalaAbbonamento('copia')}>
                          📋 Copia link
                        </button>
                      </div>
                    )
                  }
                })()}

                {/* Conferma dopo invio non iscritto */}
                {regaloCreato && (
                  <div style={{ background: 'rgba(127,214,61,0.08)', border: '1px solid rgba(127,214,61,0.25)', borderRadius: 10, padding: '12px 14px', display: 'flex', flexDirection: 'column', gap: 6 }}>
                    <div style={{ fontWeight: 700, fontSize: 13 }}>✓ Gift creato per {regaloCreato.email}</div>
                    <div style={{ fontSize: 11, color: 'var(--muted)' }}>
                      Piano {regaloCreato.piano} · {regaloCreato.mesi === 12 ? '1 anno' : `${regaloCreato.mesi} ${regaloCreato.mesi === 1 ? 'mese' : 'mesi'}`}
                    </div>
                    <div style={{ fontSize: 11, background: 'var(--surface2)', borderRadius: 6, padding: '6px 10px', wordBreak: 'break-all', border: '1px solid var(--border)' }}>
                      {regaloCreato.link}
                    </div>
                    <div style={{ display: 'flex', gap: 6, marginTop: 4 }}>
                      <button className="btn btn-secondary" style={{ flex: 1, fontSize: 12,
                        background: emailInviataStato === 'ok' ? 'rgba(74,222,128,0.15)' : undefined,
                        color: emailInviataStato === 'ok' ? '#4ade80' : undefined,
                      }} onClick={async () => {
                        setEmailInviataStato('invio')
                        const { data: { session } } = await supabase.auth.getSession()
                        const risultato = await inviaEmailGift(regaloCreato.email, regaloCreato.link, regaloCreato.piano, regaloCreato.mesi, session)
                        if (risultato.ok) {
                          setEmailInviataStato('ok')
                          toast_msg('✓ Email inviata!')
                        } else {
                          setEmailInviataStato('errore')
                          toast_msg(`⚠ ${risultato.errore || 'Errore invio email'}`)
                        }
                      }}>
                        {emailInviataStato === 'invio' ? '⏳...' : emailInviataStato === 'ok' ? '✓ Inviata' : '📧 Reinvia'}
                      </button>
                      <button className="btn btn-secondary" style={{ flex: 1, fontSize: 12 }} onClick={() => regalaAbbonamento('whatsapp')}>📲 WhatsApp</button>
                      <button className="btn btn-secondary" style={{ flex: 1, fontSize: 12 }} onClick={() => regalaAbbonamento('copia')}>📋 Copia</button>
                    </div>
                    <button className="btn btn-ghost" style={{ fontSize: 12 }} onClick={() => { setRegaloCreato(null); setEmailRegalo('') }}>
                      + Nuovo regalo
                    </button>
                  </div>
                )}

              </div>
            </div>
          )}


          {/* ══ ISCRITTI COMPLETI ══ */}
          {tab === 'iscritti' && (() => {
            const ora = new Date()
            const tutti = utenti.filter(u => u.piano !== 'admin')
            const filtrati = tutti.filter(u => {
              const matchRicerca = !ricercaIscritti ||
                `${u.nome} ${u.cognome} ${u.email}`.toLowerCase().includes(ricercaIscritti.toLowerCase())
              const matchFiltro =
                filtroIscritti === 'tutti' ? true :
                filtroIscritti === 'atleta' ? u.piano === 'atleta' :
                filtroIscritti === 'coach' ? u.piano === 'coach' :
                filtroIscritti === 'abbonato' ? (u.abbonamento_attivo && !u.regalo) :
                filtroIscritti === 'regalo' ? u.regalo :
                filtroIscritti === 'referral' ? !!u.referral_da : true
              return matchRicerca && matchFiltro
            }).sort((a, b) => new Date(b.creato_il) - new Date(a.creato_il))

            return (
              <div style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
                <div style={{ position: 'sticky', top: 0, background: 'var(--bg)', paddingBottom: 10, zIndex: 10 }}>
                  <input className="form-input" placeholder="🔍 Cerca per nome o email..."
                    value={ricercaIscritti} onChange={e => setRicercaIscritti(e.target.value)}
                    style={{ marginBottom: 8 }} />
                  <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', paddingBottom: 4 }}>
                    {[
                      { id: 'tutti', label: `Tutti (${tutti.length})` },
                      { id: 'atleta', label: 'Atleti' },
                      { id: 'coach', label: 'Coach' },
                      { id: 'abbonato', label: 'Abbonati' },
                      { id: 'regalo', label: 'Regalo' },
                      { id: 'referral', label: '🔗 Da referral' },
                    ].map(f => (
                      <button key={f.id} onClick={() => setFiltroIscritti(f.id)} style={{
                        padding: '5px 12px', borderRadius: 20, whiteSpace: 'nowrap',
                        border: `1px solid ${filtroIscritti === f.id ? 'var(--accent)' : 'var(--border)'}`,
                        background: filtroIscritti === f.id ? 'rgba(127,214,61,0.15)' : 'var(--surface2)',
                        color: filtroIscritti === f.id ? 'var(--accent)' : 'var(--muted)',
                        fontSize: 11, fontWeight: 600, cursor: 'pointer',
                      }}>{f.label}</button>
                    ))}
                  </div>
                  <div style={{ fontSize: 11, color: 'var(--muted)', marginTop: 6 }}>{filtrati.length} risultati</div>
                </div>
                {filtrati.length === 0 ? (
                  <div style={{ textAlign: 'center', color: 'var(--muted)', padding: 40, fontSize: 13 }}>Nessun risultato</div>
                ) : filtrati.map(u => {
                  const statoColor = u.abbonamento_attivo ? 'var(--green)' : u.regalo ? 'var(--purple)' : 'var(--muted)'
                  const statoLabel = u.abbonamento_attivo ? 'Abbonato' : u.regalo ? 'Regalo' : 'Free'
                  // Calcola info abbonamento dettagliate
                  const scadenzaData = u.abbonamento_al ? new Date(u.abbonamento_al) : null
                  const giorniScadenza = scadenzaData
                    ? Math.ceil((scadenzaData - ora) / (1000 * 60 * 60 * 24)) : null
                  const scadenzaLabel = scadenzaData
                    ? (giorniScadenza > 0
                        ? `Scade tra ${giorniScadenza} giorni (${formatData(scadenzaData)})`
                        : `Scaduto ${Math.abs(giorniScadenza)} giorni fa (${formatData(scadenzaData)})`)
                    : null
                  const durataAbbonamento = u.abbonamento_dal && u.abbonamento_al
                    ? Math.round((new Date(u.abbonamento_al) - new Date(u.abbonamento_dal)) / (1000 * 60 * 60 * 24 * 30))
                    : null
                  const referrente = u.referral_da ? utenti.find(x => x.id === u.referral_da) : null

                  return (
                    <div key={u.id} className="card" onClick={() => apriUtente(u)} style={{ cursor: 'pointer', marginBottom: 2 }}>
                      <div className="card-body" style={{ padding: '12px 14px' }}>
                        {/* Riga 1: nome + badge piano + stato */}
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                            <span style={{ fontWeight: 700, fontSize: 13 }}>{u.nome} {u.cognome}</span>
                            {u.bloccato && <span style={{ fontSize: 11 }}>🚫</span>}
                          </div>
                          <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                            <span className="badge" style={{ background: PIANO_COLOR[u.piano]?.bg, color: PIANO_COLOR[u.piano]?.text, fontSize: 10 }}>{u.piano}</span>
                            <span style={{ fontSize: 10, fontWeight: 800, color: statoColor, textTransform: 'uppercase' }}>{statoLabel}</span>
                          </div>
                        </div>
                        {/* Riga 2: email */}
                        <div style={{ fontSize: 11, color: 'var(--accent2)', marginBottom: 6, fontFamily: 'monospace' }}>{u.email}</div>
                        {/* Riga 3: info abbonamento */}
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                          {u.creato_il && (
                            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 10, color: 'var(--muted)' }}>
                              <span>📅 Iscritto</span>
                              <span>{formatData(u.creato_il)}</span>
                            </div>
                          )}
                          {u.abbonamento_dal && (
                            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 10, color: 'var(--muted)' }}>
                              <span>🔄 Abbonato dal</span>
                              <span>{formatData(u.abbonamento_dal)}{durataAbbonamento ? ` · ${durataAbbonamento} ${durataAbbonamento === 1 ? 'mese' : 'mesi'}` : ''}</span>
                            </div>
                          )}
                          {scadenzaLabel && (
                            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 10, color: giorniScadenza > 0 ? (giorniScadenza <= 7 ? '#fbbf24' : 'var(--muted)') : 'var(--red)', fontWeight: giorniScadenza <= 7 ? 700 : 400 }}>
                              <span>📆 Scadenza</span>
                              <span>{scadenzaLabel}</span>
                            </div>
                          )}
                          {u.ultimo_accesso && (
                            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 10, color: 'var(--muted)' }}>
                              <span>👁 Ultimo accesso</span>
                              <span>{formatData(u.ultimo_accesso)}</span>
                            </div>
                          )}
                          {referrente && (
                            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 10, color: 'var(--accent2)' }}>
                              <span>🔗 Invitato da</span>
                              <span>{referrente.nome} {referrente.cognome}</span>
                            </div>
                          )}
                          {u.regalo_da && (
                            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 10, color: 'var(--purple)' }}>
                              <span>🎁 Regalo da</span>
                              <span>{u.regalo_da === 'admin' ? 'Admin' : u.regalo_da}</span>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )
                })}
              </div>
            )
          })()}

          {/* ══ RICHIESTE UTENTI ══ */}
          {tab === 'richieste' && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
              {!richiestaSel ? (
                <>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ fontFamily: 'Syne', fontWeight: 700, fontSize: 16 }}>Richieste utenti</div>
                    <div style={{ fontSize: 12, color: 'var(--muted)' }}>{richiesteAdmin.length} totali</div>
                  </div>

                  {/* Filtri stato */}
                  <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                    {[
                      { id: 'aperta', label: 'In attesa', col: 'var(--accent2)' },
                      { id: 'completata', label: 'Completate', col: 'var(--green)' },
                      { id: 'tutte', label: 'Tutte', col: 'var(--muted)' },
                    ].map(f => {
                      const count = f.id === 'tutte' ? richiesteAdmin.length : richiesteAdmin.filter(r => r.stato === f.id).length
                      const active = filtroRichieste === f.id
                      return (
                        <button key={f.id} onClick={() => setFiltroRichieste(f.id)}
                          style={{ padding: '6px 12px', borderRadius: 16, border: `1px solid ${active ? f.col : 'var(--border)'}`,
                            background: active ? `${f.col}22` : 'var(--surface2)',
                            color: active ? f.col : 'var(--muted)', fontSize: 11, fontWeight: 700, cursor: 'pointer' }}>
                          {f.label} ({count})
                        </button>
                      )
                    })}
                  </div>

                  {/* Lista richieste */}
                  {(filtroRichieste === 'tutte' ? richiesteAdmin : richiesteAdmin.filter(r => r.stato === filtroRichieste)).length === 0 ? (
                    <div className="card"><div className="card-body" style={{ textAlign: 'center', padding: '30px 16px', fontSize: 13, color: 'var(--muted)' }}>
                      Nessuna richiesta in questa categoria
                    </div></div>
                  ) : (filtroRichieste === 'tutte' ? richiesteAdmin : richiesteAdmin.filter(r => r.stato === filtroRichieste)).map(r => {
                    const catLabel = { nuovo_esercizio: '🏋️ Nuovo esercizio', bug: '🐛 Bug', miglioramento: '💡 Miglioramento', altro: '📝 Altro' }[r.categoria] || r.categoria
                    const statoBadge = {
                      aperta: { col: 'rgba(87,184,255,0.15)', text: 'var(--accent2)', label: 'In attesa' },
                      completata: { col: 'rgba(74,222,128,0.15)', text: 'var(--green)', label: 'Completata' },
                    }[r.stato] || { col: 'var(--surface2)', text: 'var(--muted)', label: r.stato }
                    return (
                      <div key={r.id} className="card" style={{ cursor: 'pointer' }} onClick={() => apriRichiesta(r)}>
                        <div className="card-header">
                          <div style={{ flex: 1, minWidth: 0 }}>
                            <div style={{ fontSize: 11, color: 'var(--muted)', marginBottom: 2 }}>{catLabel} · {r.utente_nome || r.utente_email}</div>
                            <div className="card-title" style={{ fontSize: 14 }}>{r.titolo}</div>
                          </div>
                          <div style={{ display: 'flex', gap: 6, alignItems: 'center', flexShrink: 0 }}>
                            <span style={{ fontSize: 10, fontWeight: 700, padding: '3px 10px', borderRadius: 10, background: statoBadge.col, color: statoBadge.text }}>
                              {statoBadge.label}
                            </span>
                            <button onClick={e => { e.stopPropagation(); if (window.confirm('Eliminare questa richiesta?')) eliminaRichiestaAdmin(r.id) }}
                              title="Elimina richiesta"
                              style={{ background: 'rgba(248,113,113,0.1)', border: '1px solid rgba(248,113,113,0.35)', borderRadius: 8, padding: '4px 8px', color: 'var(--red)', cursor: 'pointer', fontSize: 14 }}>
                              🗑️
                            </button>
                          </div>
                        </div>
                        <div className="card-body" style={{ paddingTop: 0 }}>
                          <div style={{ fontSize: 12, color: 'var(--muted)', overflow: 'hidden', textOverflow: 'ellipsis', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' }}>
                            {r.testo}
                          </div>
                          <div style={{ fontSize: 10, color: 'var(--muted)', marginTop: 6 }}>
                            {new Date(r.creata_il).toLocaleDateString('it-IT', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' })}
                          </div>
                        </div>
                      </div>
                    )
                  })}
                </>
              ) : (
                /* Dettaglio richiesta */
                <>
                  <button onClick={() => { setRichiestaSel(null); setRispostaText('') }}
                    style={{ background: 'none', border: 'none', color: 'var(--accent)', cursor: 'pointer', fontSize: 13, fontWeight: 700, alignSelf: 'flex-start', padding: 0 }}>
                    ← Torna alla lista
                  </button>

                  <div className="card">
                    <div className="card-header">
                      <div style={{ flex: 1 }}>
                        <div style={{ fontSize: 11, color: 'var(--muted)', marginBottom: 2 }}>
                          {{ nuovo_esercizio: '🏋️ Nuovo esercizio', bug: '🐛 Bug', miglioramento: '💡 Miglioramento', altro: '📝 Altro' }[richiestaSel.categoria]}
                        </div>
                        <div className="card-title" style={{ fontSize: 16 }}>{richiestaSel.titolo}</div>
                      </div>
                    </div>
                    <div className="card-body">
                      <div style={{ fontSize: 13, color: 'var(--text)', whiteSpace: 'pre-wrap', lineHeight: 1.6, padding: 12, background: 'var(--surface2)', borderRadius: 10 }}>
                        {richiestaSel.testo}
                      </div>
                      <div style={{ fontSize: 11, color: 'var(--muted)', marginTop: 10 }}>
                        Da: <strong style={{ color: 'var(--accent)' }}>{richiestaSel.utente_nome || richiestaSel.utente_email}</strong> ({richiestaSel.utente_email})
                      </div>
                      <div style={{ fontSize: 11, color: 'var(--muted)' }}>
                        {new Date(richiestaSel.creata_il).toLocaleDateString('it-IT', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' })}
                      </div>
                    </div>
                  </div>

                  <div className="card">
                    <div className="card-header">
                      <div className="card-title">💬 Risposta admin</div>
                    </div>
                    <div className="card-body" style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                      <div className="form-group">
                        <label className="form-label">Risposta (opzionale)</label>
                        <textarea className="form-input" value={rispostaText}
                          onChange={e => setRispostaText(e.target.value)}
                          placeholder="Scrivi una risposta all'utente..."
                          rows={5}
                          style={{ resize: 'vertical', minHeight: 100, fontFamily: 'inherit' }} />
                      </div>
                      <button className="btn btn-primary" onClick={rispondiRichiesta} disabled={salvandoRisposta}>
                        {salvandoRisposta ? '⏳ Invio...' : '📤 Salva e notifica utente'}
                      </button>
                      <button onClick={() => { if (window.confirm('Eliminare questa richiesta?')) eliminaRichiestaAdmin(richiestaSel.id) }}
                        style={{ background: 'rgba(248,113,113,0.08)', border: '1px solid rgba(248,113,113,0.35)', borderRadius: 10, padding: '10px', color: 'var(--red)', cursor: 'pointer', fontSize: 13, fontWeight: 600 }}>
                        🗑️ Elimina richiesta
                      </button>
                      <div style={{ fontSize: 11, color: 'var(--muted)', textAlign: 'center' }}>
                        L'utente riceverà notifica in-app + email con la tua risposta
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          )}

          {/* ══ CONTENUTI — Guida / Privacy / ToS ══ */}
          {tab === 'contenuti' && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
              <div style={{ display: 'flex', borderBottom: '1px solid var(--border)', marginBottom: 16 }}>
                {[
                  { id: 'guida', label: '📖 Guida' },
                  { id: 'privacy', label: '🔒 Privacy' },
                  { id: 'tos', label: '📄 Termini' },
                  { id: 'manutenzione', label: '🔧 App' },
                ].map(t => (
                  <button key={t.id} onClick={() => setContenutiTab(t.id)} style={{
                    flex: 1, padding: '10px 4px', background: 'none', border: 'none',
                    borderBottom: `2px solid ${contenutiTab === t.id ? (t.id === 'manutenzione' && manutenzione.attiva ? 'var(--red)' : 'var(--accent)') : 'transparent'}`,
                    color: contenutiTab === t.id ? (t.id === 'manutenzione' && manutenzione.attiva ? 'var(--red)' : 'var(--accent)') : t.id === 'manutenzione' && manutenzione.attiva ? 'var(--red)' : 'var(--muted)',
                    fontWeight: 700, fontSize: 12, cursor: 'pointer', fontFamily: 'Syne',
                  }}>{t.label}{t.id === 'manutenzione' && manutenzione.attiva ? ' 🔴' : ''}</button>
                ))}
              </div>
              {!contenutiCaricati ? (
                <div style={{ textAlign: 'center', color: 'var(--muted)', padding: 40 }}>Caricamento...</div>
              ) : contenutiTab === 'manutenzione' ? (
                <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                  {/* Stato attuale */}
                  <div style={{
                    padding: '16px', borderRadius: 12,
                    background: manutenzione.attiva ? 'rgba(248,113,113,0.1)' : 'rgba(74,222,128,0.1)',
                    border: `1px solid ${manutenzione.attiva ? 'rgba(248,113,113,0.4)' : 'rgba(74,222,128,0.4)'}`,
                    textAlign: 'center',
                  }}>
                    <div style={{ fontSize: 32, marginBottom: 8 }}>{manutenzione.attiva ? '🔴' : '🟢'}</div>
                    <div style={{ fontFamily: 'Syne', fontWeight: 800, fontSize: 16, color: manutenzione.attiva ? 'var(--red)' : 'var(--green)' }}>
                      {manutenzione.attiva ? 'App in manutenzione' : 'App operativa'}
                    </div>
                    <div style={{ fontSize: 12, color: 'var(--muted)', marginTop: 4 }}>
                      {manutenzione.attiva ? 'Gli utenti vedono la schermata di manutenzione' : 'Tutti gli utenti possono accedere normalmente'}
                    </div>
                  </div>

                  {/* Messaggio */}
                  <div className="form-group">
                    <label className="form-label">Messaggio per gli utenti</label>
                    <input className="form-input" type="text"
                      value={manutenzione.messaggio}
                      onChange={e => setManutenzione(prev => ({ ...prev, messaggio: e.target.value }))}
                      placeholder="Es: Manutenzione programmata fino alle 15:00" />
                    <div style={{ fontSize: 11, color: 'var(--muted)', marginTop: 4 }}>
                      Lascia vuoto per usare il messaggio predefinito.
                    </div>
                  </div>

                  {/* Pulsanti */}
                  {manutenzione.attiva ? (
                    <button className="btn btn-primary"
                      onClick={() => salvaManutenzione(false, manutenzione.messaggio)}
                      disabled={salvandoManutenzione}>
                      {salvandoManutenzione ? '...' : '🟢 Riattiva l\'app'}
                    </button>
                  ) : (
                    <button className="btn btn-danger"
                      onClick={() => salvaManutenzione(true, manutenzione.messaggio)}
                      disabled={salvandoManutenzione}>
                      {salvandoManutenzione ? '...' : '🔴 Attiva manutenzione'}
                    </button>
                  )}
                  <div style={{ fontSize: 11, color: 'var(--muted)', textAlign: 'center', lineHeight: 1.6 }}>
                    L'admin non vede mai la schermata di manutenzione.
                  </div>
                </div>
              ) : (
                <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                  <div style={{ fontSize: 12, color: 'var(--muted)', lineHeight: 1.6 }}>
                    {contenutiTab === 'guida' && 'Testo della guida all\'app visibile agli utenti.'}
                    {contenutiTab === 'privacy' && 'Testo della Privacy Policy visibile nella sezione Legale.'}
                    {contenutiTab === 'tos' && 'Testo dei Termini di Servizio visibili nella sezione Legale.'}
                  </div>
                  <textarea className="form-input" rows={18}
                    value={contenuti[contenutiTab] || ''}
                    onChange={e => setContenutiState(prev => ({ ...prev, [contenutiTab]: e.target.value }))}
                    style={{ fontSize: 12, resize: 'vertical', fontFamily: 'Instrument Sans, sans-serif', lineHeight: 1.6 }}
                    placeholder="Scrivi il testo qui..." />
                  <button className="btn btn-primary"
                    onClick={() => salvaContenuto(contenutiTab, contenuti[contenutiTab])}
                    disabled={salvandoContenuti}>
                    {salvandoContenuti ? 'Salvataggio...' : '✓ Salva'}
                  </button>
                </div>
              )}
            </div>
          )}

          {/* GESTIONE ESERCIZI */}
          {tab === 'esercizi' && (() => {
            const eserciziFiltrati = esercizi.filter(ex => {
              const matchCat = filtroCategoria === 'Tutte' || ex.categoria === filtroCategoria
              const matchRicerca = !ricercaEx || ex.nome.toLowerCase().includes(ricercaEx.toLowerCase()) || (ex.categoria || '').toLowerCase().includes(ricercaEx.toLowerCase())
              return matchCat && matchRicerca
            })

            return (
              <div style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
                {/* Barra ricerca */}
                <div style={{ position: 'sticky', top: 0, background: 'var(--bg)', paddingBottom: 10, zIndex: 10 }}>
                  <input
                    className="form-input"
                    placeholder="🔍 Cerca esercizio..."
                    value={ricercaEx}
                    onChange={e => setRicercaEx(e.target.value)}
                    style={{ marginBottom: 10 }}
                  />
                  {/* Filtri categoria */}
                  <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', paddingBottom: 4 }}>
                    {CATEGORIE_EX.map(c => (
                      <button
                        key={c}
                        onClick={() => setFiltroCategoria(c)}
                        style={{
                          padding: '5px 12px',
                          borderRadius: 20,
                          border: `1px solid ${filtroCategoria === c ? 'var(--accent)' : 'var(--border)'}`,
                          background: filtroCategoria === c ? 'rgba(127,214,61,0.15)' : 'var(--surface2)',
                          color: filtroCategoria === c ? 'var(--accent)' : 'var(--muted)',
                          fontSize: 11,
                          fontWeight: 600,
                          cursor: 'pointer',
                          transition: 'all 0.2s',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        {c}
                      </button>
                    ))}
                  </div>
                  {/* Contatore risultati */}
                  <div style={{ fontSize: 11, color: 'var(--muted)', marginTop: 8 }}>
                    {eserciziFiltrati.length} esercizi{filtroCategoria !== 'Tutte' ? ` · ${filtroCategoria}` : ''}
                  </div>
                </div>

                {/* Lista esercizi */}
                {esercizi.length === 0 ? (
                  <div style={{ textAlign: 'center', color: 'var(--muted)', padding: 40, fontSize: 13 }}>Caricamento esercizi...</div>
                ) : eserciziFiltrati.length === 0 ? (
                  <div style={{ textAlign: 'center', color: 'var(--muted)', padding: 40, fontSize: 13 }}>Nessun esercizio trovato</div>
                ) : eserciziFiltrati.map((ex, i) => (
                  <div key={ex.id}>
                  <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: '12px 0',
                    borderBottom: i < eserciziFiltrati.length - 1 && confermaEliminaEx?.id !== ex.id ? '1px solid var(--border)' : 'none',
                  }}>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontWeight: 600, fontSize: 13 }}>{ex.nome}</div>
                      <div style={{ display: 'flex', gap: 6, marginTop: 4, flexWrap: 'wrap' }}>
                        <span style={{
                          fontSize: 10, fontWeight: 700, padding: '2px 7px', borderRadius: 10,
                          background: ex.categoria === 'Calisthenics' ? 'rgba(179,92,0,0.15)' :
                                      ex.categoria === 'Pesistica' ? 'rgba(87,184,255,0.15)' :
                                      ex.categoria === 'Corpo libero' ? 'rgba(74,222,128,0.15)' :
                                      ex.categoria === 'Kettlebell' ? 'rgba(199,125,255,0.15)' :
                                      'rgba(255,255,255,0.08)',
                          color: ex.categoria === 'Calisthenics' ? 'var(--yellow)' :
                                 ex.categoria === 'Pesistica' ? 'var(--accent2)' :
                                 ex.categoria === 'Corpo libero' ? 'var(--green)' :
                                 ex.categoria === 'Kettlebell' ? 'var(--purple)' :
                                 ex.categoria === 'CrossFit' ? 'var(--accent3)' :
                                 ex.categoria === 'Animal Flow' ? 'var(--purple)' :
                                 'var(--muted)',
                        }}>
                          {ex.categoria}
                        </span>
                        {(ex.varianti || []).length > 0 && (
                          <span style={{ fontSize: 10, color: 'var(--muted)' }}>↑ {(ex.varianti || []).length} var.</span>
                        )}
                        {(ex.regressioni || []).length > 0 && (
                          <span style={{ fontSize: 10, color: 'var(--muted)' }}>↓ {(ex.regressioni || []).length} regr.</span>
                        )}
                      </div>
                    </div>
                    <div style={{ display: 'flex', gap: 6, flexShrink: 0, marginLeft: 8 }}>
                      <button
                        onClick={() => apriModificaEsercizio(ex)}
                        style={{ background: 'none', border: '1px solid var(--border)', borderRadius: 8, padding: '6px 12px', color: 'var(--accent)', cursor: 'pointer', fontSize: 12, fontWeight: 700 }}
                      >
                        Modifica
                      </button>
                      <button
                        onClick={() => setConfermaEliminaEx(confermaEliminaEx?.id === ex.id ? null : ex)}
                        style={{ background: confermaEliminaEx?.id === ex.id ? 'rgba(248,113,113,0.15)' : 'none', border: '1px solid rgba(248,113,113,0.3)', borderRadius: 8, padding: '6px 10px', color: 'var(--red)', cursor: 'pointer', fontSize: 14 }}
                      >
                        🗑️
                      </button>
                    </div>
                  </div>
                  {confermaEliminaEx?.id === ex.id && (
                    <div style={{ margin: '4px 0 6px', padding: '10px 12px', background: 'rgba(248,113,113,0.08)', border: '1px solid rgba(248,113,113,0.25)', borderRadius: 10, display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10 }}>
                      <div style={{ fontSize: 12, color: 'var(--red)', fontWeight: 600 }}>Eliminare «{ex.nome}»?</div>
                      <div style={{ display: 'flex', gap: 6, flexShrink: 0 }}>
                        <button onClick={() => setConfermaEliminaEx(null)}
                          style={{ fontSize: 12, padding: '4px 10px', borderRadius: 8, border: '1px solid var(--border)', background: 'var(--surface2)', color: 'var(--muted)', cursor: 'pointer' }}>
                          Annulla
                        </button>
                        <button onClick={() => eliminaEsercizio(ex.id)}
                          style={{ fontSize: 12, padding: '4px 10px', borderRadius: 8, border: '1px solid rgba(248,113,113,0.4)', background: 'rgba(248,113,113,0.15)', color: 'var(--red)', cursor: 'pointer', fontWeight: 700 }}>
                          Elimina
                        </button>
                      </div>
                    </div>
                  )}
                  </div>
                ))}
              </div>
            )
          })()}

        </>}

        {/* ══ SPONSOR ══ */}
        {tab === 'sponsor' && (
          <div style={{ padding: '4px 0' }}>
            <PannelloSponsor />
          </div>
        )}
      </div>

      {/* ══════ MODALE DETTAGLIO UTENTE ══════ */}
      {utenteSel && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)', display: 'flex', alignItems: 'flex-end', justifyContent: 'center', zIndex: 200 }} onClick={() => setUtenteSel(null)}>
          <div onClick={e => e.stopPropagation()} style={{ background: 'var(--bg)', borderRadius: '20px 20px 0 0', padding: 0, width: '100%', maxWidth: 430, maxHeight: '92vh', overflowY: 'auto', border: '1px solid var(--border)' }} className="slide-up">

            {/* Header modale */}
            <div style={{ position: 'sticky', top: 0, background: 'var(--bg)', padding: '18px 20px 14px', borderBottom: '1px solid var(--border)', zIndex: 10 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ fontFamily: 'Syne', fontWeight: 700, fontSize: 16 }}>Gestione utente</div>
                <button onClick={() => setUtenteSel(null)} style={{ background: 'none', border: 'none', color: 'var(--muted)', cursor: 'pointer', fontSize: 20 }}>✕</button>
              </div>
            </div>

            <div style={{ padding: '16px 20px', display: 'flex', flexDirection: 'column', gap: 14 }}>

              {/* Dati utente */}
              <div className="card">
                <div className="card-body">
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 8 }}>
                    <div>
                      <div style={{ fontFamily: 'Syne', fontWeight: 700, fontSize: 16 }}>{utenteSel.nome} {utenteSel.cognome}</div>
                      <div style={{ fontSize: 12, color: 'var(--muted)', marginTop: 2 }}>{utenteSel.email}</div>
                    </div>
                    <span className="badge" style={{ background: PIANO_COLOR[utenteSel.piano]?.bg, color: PIANO_COLOR[utenteSel.piano]?.text }}>{utenteSel.piano}</span>
                  </div>
                  <div style={{ fontSize: 11, color: 'var(--muted)', marginTop: 8, lineHeight: 2 }}>
                    <div>Registrato: {formatData(utenteSel.creato_il)}</div>
                    {utenteSel.abbonamento_dal && <div>Abbonato dal: {formatData(utenteSel.abbonamento_dal)}</div>}
                    {utenteSel.abbonamento_al && (
                      <div>Abbonamento scade: <span style={{ color: new Date(utenteSel.abbonamento_al) > new Date() ? 'var(--green)' : 'var(--red)' }}>{formatData(utenteSel.abbonamento_al)}</span></div>
                    )}
                    {utenteSel.ultimo_accesso && (
                      <div>Ultimo accesso: <span style={{ color: 'var(--accent)' }}>{formatData(utenteSel.ultimo_accesso)}</span></div>
                    )}
                    {utenteSel.referral_da && (() => {
                      const chi = utenti.find(x => x.id === utenteSel.referral_da)
                      return chi ? <div>Invitato da: <span style={{ color: 'var(--accent2)', fontWeight: 600 }}>{chi.nome} {chi.cognome} ({chi.email})</span></div> : null
                    })()}
                  </div>
                  {utenteSel.bloccato && (
                    <div style={{ marginTop: 10, padding: '8px 12px', background: 'rgba(248,113,113,0.1)', border: '1px solid rgba(248,113,113,0.3)', borderRadius: 10, fontSize: 12, color: 'var(--red)' }}>
                      🚫 <strong>BLOCCATO</strong>{utenteSel.bloccato_motivo ? ` — ${utenteSel.bloccato_motivo}` : ''}
                    </div>
                  )}
                </div>
              </div>

              {/* Cambio piano */}
              {utenteSel.piano !== 'admin' && (
                <div className="card">
                  <div className="card-header"><div className="card-title">Piano</div></div>
                  <div className="card-body">
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
                      {['atleta', 'coach'].map(p => (
                        <button key={p} onClick={() => cambiaPianoUtente(utenteSel, p)} disabled={utenteSel.piano === p || salvando}
                          style={{ padding: '10px', borderRadius: 10, border: `2px solid ${utenteSel.piano === p ? PIANO_COLOR[p]?.text : 'var(--border)'}`,
                            background: utenteSel.piano === p ? PIANO_COLOR[p]?.bg : 'var(--surface2)', cursor: utenteSel.piano === p ? 'default' : 'pointer',
                            fontFamily: 'Syne', fontWeight: 700, fontSize: 13,
                            color: utenteSel.piano === p ? PIANO_COLOR[p]?.text : 'var(--muted)', opacity: salvando ? 0.5 : 1 }}>
                          {p === 'atleta' ? '🏋️ Atleta' : '👨‍🏫 Coach'}
                          {utenteSel.piano === p && ' ✓'}
                        </button>
                      ))}
                    </div>
                  </div>
                </div>
              )}

              {/* Estendi abbonamento */}
              {utenteSel.piano !== 'admin' && (utenteSel.abbonamento_attivo || utenteSel.regalo) && (() => {
                async function impostaScadenzaAbbonamento(dataStr) {
                  if (!dataStr) { toast_msg('Seleziona una data'); return }
                  const nuovaScadenza = new Date(dataStr).toISOString()
                  setSalvando(true)
                  const res = await adminUpdate(utenteSel.id, { abbonamento_al: nuovaScadenza }, 'imposta_abbonamento_al')
                  setSalvando(false)
                  if (res.error) { toast_msg('Errore: ' + res.error); return }
                  const dataFmt = new Date(dataStr).toLocaleDateString('it-IT', { day: 'numeric', month: 'long', year: 'numeric' })
                  const isCoach = utenteSel.piano === 'coach'
                  await inviaNotifica(
                    utenteSel.id,
                    isCoach ? '🏆 Regalo dal team FitProgress!' : '🎉 Abbonamento esteso!',
                    isCoach
                      ? `Grazie per il tuo impegno su FitProgress! Il tuo abbonamento è stato esteso fino al ${dataFmt}. Continua così! 💪`
                      : `Il tuo abbonamento è stato esteso fino al ${dataFmt}. Buon allenamento!`,
                    'abbonamento'
                  )
                  // Email
                  try {
                    const { data: { session: sesAbb } } = await supabase.auth.getSession()
                    if (sesAbb) {
                      await fetch(funzioneUrl('send-gift-email'), {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${sesAbb.access_token}` },
                        body: JSON.stringify({
                          tipo: 'estensione_abbonamento',
                          destinatario_email: utenteSel.email,
                          destinatario_nome: utenteSel.nome,
                          giorni: null,
                          nuova_scadenza: nuovaScadenza,
                          piano: utenteSel.piano,
                          is_premio: isCoach,
                        }),
                      })
                    }
                  } catch (e) {
                    // L'estensione è già applicata a DB: qui fallisce solo l'email.
                    // Va segnalato, altrimenti l'admin crede che l'utente sia stato avvisato.
                    console.error('[send-gift-email] invio fallito:', e)
                    toast_msg('⚠️ Abbonamento esteso, ma invio email fallito')
                  }
                  setEstendiConfermato({ giorni: null, nuovaScadenza, tipo: 'abbonamento', dataEsatta: dataStr })
                  setDataPersonalizzata('')
                  setUtenteSel(prev => prev ? { ...prev, abbonamento_al: nuovaScadenza } : null)
                  setUtenti(prev => prev.map(u2 => u2.id === utenteSel.id ? { ...u2, abbonamento_al: nuovaScadenza } : u2))
                  setTimeout(() => caricaUtenti(), 500)
                }

                return (
                  <div className="card">
                    <div className="card-header"><div className="card-title">🎁 Estendi abbonamento</div></div>
                    <div className="card-body" style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                      <div style={{ fontSize: 12, color: 'var(--muted)' }}>Imposta una nuova data di scadenza per l'abbonamento.</div>

                      {/* Modale conferma */}
                      {estendiConfermato && estendiConfermato.tipo === 'abbonamento' && (
                        <div style={{ background: 'rgba(127,214,61,0.1)', border: '1px solid var(--accent)', borderRadius: 12, padding: '16px', display: 'flex', flexDirection: 'column', gap: 10 }}>
                          <div style={{ fontSize: 22, textAlign: 'center' }}>✅</div>
                          <div style={{ fontFamily: 'Syne', fontWeight: 700, fontSize: 14, textAlign: 'center' }}>Abbonamento esteso!</div>
                          <div style={{ fontSize: 12, color: 'var(--muted)', textAlign: 'center', lineHeight: 1.6 }}>
                            Nuova scadenza: <strong style={{ color: 'var(--accent)' }}>
                              {new Date(estendiConfermato.nuovaScadenza).toLocaleDateString('it-IT', { day: 'numeric', month: 'long', year: 'numeric' })}
                            </strong>
                          </div>
                          <button className="btn btn-primary" onClick={() => setEstendiConfermato(null)} style={{ fontSize: 14 }}>OK</button>
                        </div>
                      )}

                      {/* Data esatta */}
                      <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                        <input className="form-input" type="date"
                          value={dataPersonalizzata}
                          onChange={e => setDataPersonalizzata(e.target.value)}
                          min={new Date().toISOString().split('T')[0]}
                          style={{ flex: 1, fontSize: 13, padding: '10px 12px' }} />
                        <button className="btn btn-primary" style={{ width: 'auto', padding: '10px 16px' }}
                          onClick={() => impostaScadenzaAbbonamento(dataPersonalizzata)} disabled={salvando || !dataPersonalizzata}>
                          Estendi
                        </button>
                      </div>
                    </div>
                  </div>
                )
              })()}

              {/* Blocca/sblocca */}
              {utenteSel.piano !== 'admin' && (
                <div className="card">
                  <div className="card-header"><div className="card-title">{utenteSel.bloccato ? 'Sblocca utente' : 'Blocca utente'}</div></div>
                  <div className="card-body" style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                    {!utenteSel.bloccato ? (
                      <>
                        <div style={{ fontSize: 12, color: 'var(--muted)', lineHeight: 1.6 }}>
                          L'utente bloccato vedrà una schermata "Account sospeso" e non potrà usare l'app. I suoi dati restano intatti.
                        </div>
                        <input className="form-input" placeholder="Motivo del blocco (opzionale)"
                          value={motivoBlocco} onChange={e => setMotivoBlocco(e.target.value)} style={{ fontSize: 13 }} />
                        <button className="btn btn-danger" onClick={() => bloccaSbloccaUtente(utenteSel, true, motivoBlocco)} disabled={salvando}>
                          🚫 Blocca utente
                        </button>
                      </>
                    ) : (
                      <button className="btn btn-primary" onClick={() => bloccaSbloccaUtente(utenteSel, false, null)} disabled={salvando}>
                        ✓ Sblocca utente
                      </button>
                    )}
                  </div>
                </div>
              )}

              {/* Note admin */}
              <div className="card">
                <div className="card-header"><div className="card-title">Note admin (interne)</div></div>
                <div className="card-body" style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                  <textarea className="form-input" rows={3} placeholder="Es: pagamento manuale ricevuto, cliente VIP, ecc."
                    value={noteAdmin} onChange={e => setNoteAdmin(e.target.value)}
                    style={{ fontSize: 13, resize: 'vertical', fontFamily: 'Instrument Sans, sans-serif' }} />
                  <button className="btn btn-secondary" onClick={() => salvaNoteAdmin(utenteSel, noteAdmin)} disabled={salvando}>
                    Salva note
                  </button>
                </div>
              </div>

              {/* Zona pericolosa — cancellazione */}
              {utenteSel.piano !== 'admin' && (
                <div style={{ marginTop: 4 }}>
                  <div style={{ fontSize: 10, fontWeight: 700, color: 'var(--red)', letterSpacing: 1.5, textTransform: 'uppercase', marginBottom: 10 }}>Zona pericolosa</div>
                  <button className="btn btn-danger" onClick={() => { setConfermaElimina(utenteSel); setEmailConferma('') }}>
                    🗑 Cancella utente definitivamente
                  </button>
                </div>
              )}

            </div>
          </div>
        </div>
      )}

      {/* ══════ MODALE CONFERMA CANCELLAZIONE ══════ */}
      {confermaElimina && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.85)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 300, padding: 20 }}>
          <div style={{ background: 'var(--surface)', borderRadius: 20, padding: 24, width: '100%', maxWidth: 400, border: '1px solid rgba(248,113,113,0.3)' }} className="slide-up">
            <div style={{ fontSize: 40, textAlign: 'center', marginBottom: 12 }}>⚠️</div>
            <div style={{ fontFamily: 'Syne', fontWeight: 800, fontSize: 18, textAlign: 'center', marginBottom: 10 }}>Cancellazione definitiva</div>
            <div style={{ fontSize: 13, color: 'var(--muted)', marginBottom: 16, lineHeight: 1.6 }}>
              Stai per cancellare <strong style={{ color: 'var(--text)' }}>{confermaElimina.nome} {confermaElimina.cognome}</strong>.<br />
              Questa azione è <strong style={{ color: 'var(--red)' }}>irreversibile</strong> — verranno eliminati account, tracking, gruppi, messaggi e ogni dato collegato.
            </div>
            <div style={{ fontSize: 12, color: 'var(--text)', marginBottom: 8 }}>
              Per confermare, digita l'email dell'utente: <strong>{confermaElimina.email}</strong>
            </div>
            <input className="form-input" placeholder="Digita l'email qui" value={emailConferma} onChange={e => setEmailConferma(e.target.value)}
              style={{ fontSize: 13, marginBottom: 16 }} autoFocus />
            <div style={{ display: 'flex', gap: 10 }}>
              <button className="btn btn-ghost" style={{ flex: 1 }} onClick={() => { setConfermaElimina(null); setEmailConferma('') }} disabled={salvando}>
                Annulla
              </button>
              <button className="btn btn-danger" style={{ flex: 1 }}
                onClick={() => cancellaUtente(confermaElimina)}
                disabled={salvando || emailConferma.trim().toLowerCase() !== confermaElimina.email.toLowerCase()}>
                {salvando ? '...' : 'Cancella'}
              </button>
            </div>
          </div>
        </div>
      )}

      {toast && <div className="toast">{toast}</div>}
    </div>
  )
}
